module.exports = __webpack_public_path__ + "img/title1.27024930.png";